import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { cranstonConfig } from "./data";

export default function CranstonPage() {
  return <CityPageTemplate config={cranstonConfig} />;
}